import React from 'react';
import classes from './index.module.scss';

const ReplyMessageOptions = ({ setReplyBoxVisibility, sendMessage }) => {

  const cancelReplyMessage = () => {
    setReplyBoxVisibility(false);
  }

  return (
    <div className={classes.Message_Footer}>
      <div>
        <button
          className="btnSizes filledBtn"
        >
          Send Message
        </button>
        <button
          onClick={cancelReplyMessage}
          className="btnSizes transparentBtn border-0 ml-5"
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default ReplyMessageOptions;